import { AdditionalInformationFormData } from "./AdditionalInformationFormData";
import { ObservationEntryFormData } from "./ObservationEntryFromData";

class ManualLabResultsEntryFormModel {
    public addtionalInformationData: AdditionalInformationFormData;
    public observations: ObservationEntryFormData[];

    public static default(): ManualLabResultsEntryFormModel {
        return {
            addtionalInformationData: new AdditionalInformationFormData(),
            observations: [ObservationEntryFormData.createEmpty()]
        };
    }
}

export { ManualLabResultsEntryFormModel };
